import { Injectable, EventEmitter} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Loyaltic } from './api-url.constants';
import { Observable, Subject } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';

export interface ReportChartConfig {
  showTotalUsers: boolean;
  showMarketingOptIns: boolean;
  showTotalCodes: boolean;
  showTotalRewards: boolean;
  showParticipations: boolean;
  showTotalPointsCollected: boolean;
  showAvgReceiptsPerUser: boolean;
  showAvgPointsPerUser: boolean;
  showAvgTotalCollectedPerUser: boolean;
  showOptInsChart: boolean;
  showCodeEntriesChart: boolean;
  showRewardsChart: boolean;
  showParticipationsChart: boolean;
  showRegistrationTrend: boolean;
  showReceiptTrend: boolean;
  showRewardTrend: boolean;
  showProductTrend: boolean;
  showSummaryAnalysis: boolean;
  showRewardAnalytics: boolean;
  showPointsAnalytics: boolean;
  totalUsersLabel: string;
  marketingOptInsLabel: string;
  totalCodesLabel: string;
  totalRewardsLabel: string;
  participationsLabel: string;
}

@Injectable({
  providedIn: 'root'
})
export class CoreService {
  public pointsEmitter = new EventEmitter<any>();
  public responseLoadedEmitter = new EventEmitter<boolean>();
  isReceiptApproved = false;
  recptPartitionKey = '';
  failedChecks = 0;
  recptRowKey = '';
  scanningReasons:any[] = [];
  public rejectedReasons = [];
  constructor(private http: HttpClient) { }



  signUp(userName) {
    return this.http.post(environment.baseUrl + Loyaltic.API.CaptureEmail, JSON.stringify({ Email: userName }))
      .toPromise().then(response => {
        return response;
      });
  }

  getLiveConfig() {
    return this.http.get(environment.baseUrl + Loyaltic.API.LiveConfig)
      .toPromise().then(response => {
        return response;
      });
  }

  logIn(body) {
    return this.http.post(environment.baseUrl + Loyaltic.API.Login, JSON.stringify(body))
      .toPromise().then(response => {
        return response;
      });
  }

  upLoadReceipt(payload) {
    return this.http.post(environment.baseUrl + Loyaltic.API.Upload,
      payload)
      .toPromise().then(response => {
        return response;
      });
  }

  participate(payload) {
    return this.http.post(environment.baseUrl + Loyaltic.API.Participate,
      payload)
      .toPromise().then(response => {
        return response;
      });
  }

  RegUploadWithRealTimeScanning(payload) {
    return this.http.post(environment.baseUrl + Loyaltic.API.RegUploadWithRealTimeScanning,
      payload)
      .toPromise().then(response => {
        return response;
      });
  }

  loginWithUploadReceipt(payload) {
    return this.http.post(environment.baseUrl + Loyaltic.API.LoginWithUploadReceipt,
      payload)
      .toPromise().then(response => {
        return response;
      });
  }

  getRegistrationTrends(startDate?: string, endDate?: string, period: number = 0): Observable<any> {
    let url = environment.baseUrl + Loyaltic.API.RegistrationTrends + `?period=${period}`;
    if (startDate) {
      url += `&startDate=${startDate}`;
    }
    if (endDate) {
      url += `&endDate=${endDate}`;
    }
    return this.http.get(url);
  }

  getReceiptTrends(startDate?: string, endDate?: string, period: number = 0): Observable<any> {
    let url = environment.baseUrl + Loyaltic.API.ReceiptTrends + `?period=${period}`;
    if (startDate) {
      url += `&startDate=${startDate}`;
    }
    if (endDate) {
      url += `&endDate=${endDate}`;
    }
    return this.http.get(url);
  }

  getRewardTrends(startDate?: string, endDate?: string, period: number = 0): Observable<any> {
    let url = environment.baseUrl + Loyaltic.API.RewardTrends + `?period=${period}`;
    if (startDate) {
      url += `&startDate=${startDate}`;
    }
    if (endDate) {
      url += `&endDate=${endDate}`;
    }
    return this.http.get(url);
  }

  getProductTrends(startDate?: string, endDate?: string): Observable<any> {
    let url = environment.baseUrl + Loyaltic.API.ProductTrends;
    const params: string[] = [];
    if (startDate) {
      params.push(`startDate=${startDate}`);
    }
    if (endDate) {
      params.push(`endDate=${endDate}`);
    }
    if (params.length > 0) {
      url += '?' + params.join('&');
    }
    return this.http.get(url);
  }

  fetchReport(type: any, startDate?: string, endDate?: string) {
    let url = environment.baseUrl + `${Loyaltic.API.FetchTotal}/${type}`;
    const params: string[] = [];
    if (startDate) params.push(`startDate=${startDate}`);
    if (endDate) params.push(`endDate=${endDate}`);
    if (params.length > 0) url += '?' + params.join('&');
    return this.http.get(url);
  }

  getReportChartConfig(): Observable<ReportChartConfig> {
    return this.http.get<ReportChartConfig>(environment.baseUrl + Loyaltic.API.ReportChartConfig);
  }

  updateReportChartConfig(config: ReportChartConfig): Observable<ReportChartConfig> {
    return this.http.put<ReportChartConfig>(environment.baseUrl + Loyaltic.API.ReportChartConfig, config);
  }

  getAvailableGames(userId) {
    return this.http.get(environment.baseUrl + Loyaltic.API.AvailableGames + '?userid=' + userId).toPromise().then(response => {
      return response;
    });
  }

  play(userId, playType) {
    return this.http.post(environment.baseUrl + Loyaltic.API.Play, JSON.stringify({ UserId: userId, PlaySource: playType }))
      .toPromise().then(response => {
        return response;
      });
  }

  getfbBonuspoint(body, userId) {
    return this.http.post(environment.baseUrl + Loyaltic.API.FbSharePoints + '?userid=' + userId, JSON.stringify(body)).toPromise().then(response => {
      return response;
    });
  }

   testwin(rewardid) {
    return this.http.get(environment.baseUrl + Loyaltic.API.TestWin + '?reward=' + rewardid)
      .toPromise().then(response => {
        return response;
      });
  }



  captureAddress(body) {
    return this.http.post(environment.baseUrl + Loyaltic.API.CaptureAddress, JSON.stringify(body))
      .toPromise().then(response => {
        return response;
      });
  }

  captureDigitalWin(payload) {
    return this.http.post(environment.baseUrl + Loyaltic.API.CaptureDigitalWin , payload)
      .toPromise().then(response => {
        return response;
      });
  }

  stripePay(body) {
    return this.http.post(environment.baseUrl + Loyaltic.API.StripePay, JSON.stringify(body))
      .toPromise().then(response => {
        return response;
      });
  }

  confirmReceiptUpload(partitionKey, rowKey) {
    return this.http.post(environment.baseUrl +
      Loyaltic.API.confirmuploadafterscanning + '?PartitionKey=' + partitionKey + '&RowKey=' + rowKey, null)
      .toPromise().then(response => {
        return response;
      });
  }

  Notifyuser(userid, RewardPartitionkey) {
    return this.http.post(environment.baseUrl +
      Loyaltic.API.Notifyuser + '?userId=' + userid + '&RewardPartitionkey=' + RewardPartitionkey, null)
      .toPromise().then(response => {
        return response;
      });
  }

  emailReminder(body) {
    return this.http.post(environment.baseUrl + Loyaltic.API.Emailreminder, JSON.stringify(body)).toPromise().then(response => {
      return response;
    });
  }

  register(body) {
    return this.http.post(environment.baseUrl + Loyaltic.API.Register, JSON.stringify(body)).toPromise().then(response => {
      return response;
    });
  }

  forgotPassword(email) {
    return this.http.post(environment.baseUrl + Loyaltic.API.ForgotPassword, JSON.stringify({ Email: email }))
      .toPromise().then(response => {
        return response;
      });
  }

  resetPassword(body) {
    return this.http.post(environment.baseUrl + Loyaltic.API.ResetPassword, JSON.stringify(body))
      .toPromise().then(response => {
        return response;
      });
  }

  getLatestAddress(id) {
    return this.http.get(environment.baseUrl + Loyaltic.API.LatestAddress + '?userId=' + id).toPromise().then(response => {
      return response;
    });
  }

  postOrderReward(body) {
    return this.http.post(environment.baseUrl + Loyaltic.API.OrderReward, JSON.stringify(body)).toPromise().then(response => {
      return response;
    });
  }

  getRewards(culture, userId = null) {
    let query = `?culture=${culture}`;
    if (userId) {
      query = `${query}&userid=${userId}`;
    }
    return this.http.get(environment.baseUrl + Loyaltic.API.Rewards + query).toPromise().then(response => {
      return response;
    });
  }


  getprofile(userId) {  
    return this.http.get(environment.baseUrl + Loyaltic.API.profile + '?userId=' + userId).toPromise().then(response => {
      return response;
    });
  }

  getPoints(userId) {
    return this.http.get(environment.baseUrl + Loyaltic.API.Points + '?userid=' + userId)
      .toPromise().then(response => {
        return response;
      });
  }

  getProducts(){
    return this.http.get(environment.baseUrl + Loyaltic.API.products).toPromise().then(response => {
      return response;
    })
  }

  getSummaryStats(): Observable<any> {
    return this.http.get(environment.baseUrl + Loyaltic.API.SummaryStats);
  }
  getRewardRedemptionCount(): Observable<any> {
    return this.http.get(environment.baseUrl + Loyaltic.API.RewardRedemptionCount);
  }
  getRewardPopularity(): Observable<any> {
    return this.http.get(environment.baseUrl + Loyaltic.API.RewardPopularity);
  }
  getPointsReport(): Observable<any> {
    return this.http.get(environment.baseUrl + Loyaltic.API.PointsReport);
  }
  getUserPointsExport(): Observable<any> {
    return this.http.get(environment.baseUrl + Loyaltic.API.PointsExport);
  }

}
